<template>
  <div>
    <PageHeader :schema="$schemas.product" />
    <PageContent>
      <DynamicFormPage :schema="$schemas.product" :service="$api.products" />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicFormPage from '@/components/dynamics/DynamicFormPage';

export default {
  name: 'CreateProduct',
  components: { PageHeader, PageContent, DynamicFormPage },
};
</script>
